<template>
  <div class="topic-info" ref="topicInfo">
    <div class="parent">{{ `${info.main_name}-${info.mileage_name}` }}</div>
    <div class="title">{{ info.title }}</div>
    <div class="nav-list">
      <div class="nav-item" :class="{active: navIndex === index}" v-for="(item, index) in navList" :key="index" @click="navChange(index)">
        <span class="name">{{ item }}</span>
        <van-icon :name="navIndex === index ? 'arrow-down' : 'arrow-up'" />
      </div>
    </div>
    <div class="nav-content" :class="`nav${navIndex}`" v-if="navIndex !== ''">
      <div class="nav-content-item" v-if="navIndex === 0">
        <div class="scroll">
          <div class="scdivore-standard">
            <span class="score">0分</span>
            <span>{{ info.zero_norm }}</span>
          </div>
          <div class="scdivore-standard">
            <span class="score">0.5分</span>
            <span>{{ info.half_norm }}</span>
          </div>
          <div class="scdivore-standard">
            <span class="score">1分</span>
            <span>{{ info.full_norm }}</span>
          </div>
        </div>
      </div>
      <div class="nav-content-item" v-if="navIndex === 1">
        <div class="scroll">
          <p>{{ info.tool || '无' }}</p>
        </div>
      </div>
      <div class="nav-content-item" v-if="navIndex === 2">
        <div class="scroll">
          <p v-html="info.operate"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopicInfo",
  props: {
    info: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      navList: ["得分标准", "教具", "操作"],
      navIndex: ""
    }
  },
  mounted() {
    // 添加全局点击监听器
    document.addEventListener('click', this.handleDocumentClick);
  },
  beforeDestroy() {
    // 移除全局点击监听器
    document.removeEventListener('click', this.handleDocumentClick);
  },
  methods: {
    navChange(index) {
      this.navIndex = this.navIndex === index ? '' : index;
    },
    handleDocumentClick(e) {
      if (this.navIndex !== '' && this.$refs.topicInfo) {
        const target = e.target;
        const isNavElement = target.closest('.nav-item') || target.closest('.nav-content');
        if (!isNavElement) {
          this.navIndex = '';
        }
      }
    }
  },
}
</script>

<style lang="less" scoped>
.topic-info {
  background: #fff7ee;
  box-shadow: 0 0 0.1rem 1px rgba(255, 124, 36, 0.5);
  border-radius: 0.2rem;
  padding: 0.15rem 0.15rem 0;
  position: relative;
  .parent {
    height: 0.25rem;
    background: linear-gradient(180deg, #ff8927 0%, #ff6238 100%);
    border-radius: 0.06rem;
    font-size: 0.14rem;
    color: #fff;
    margin-right: 0.12rem;
    float: left;
    line-height: 0.25rem;
    overflow: hidden;
    padding: 0 0.1rem;
  }
  .title {
    font-size: 0.14rem;
    color: #5a3600;
    line-height: 0.28rem;
    margin-bottom: 0.1rem;
  }
  .nav-list {
    display: flex;
    border-bottom: 1px dashed #ff7c24;
    .nav-item {
      width: 0.8rem;
      height: 0.22rem;
      background: url("~@/assets/img/tip-bg.png") center center / 100% 100%
        no-repeat;
      font-size: 0.1rem;
      color: #630200;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 0.03rem;
      box-sizing: border-box;
      margin-right: 0.1rem;
      .name {
        margin-right: 0.02rem;
      }
      &.active {
        background: url("~@/assets/img/tip-bg-active.png") center center / 100%
          100% no-repeat;
      }
    }
  }
  .nav-content {
    padding: 0.1rem 0 0.1rem;
    position: absolute;
    width: 97%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9;
    &::before {
      content: "";
      display: block;
      width: 0.1rem;
      height: 0.1rem;
      background: #fffbe6;
      border-top: 1px dotted #ffce00;
      border-left: 1px dotted #ffce00;
      border-radius: 0.02rem;
      transform: rotate(45deg);
      position: absolute;
      top: 0.05rem;
    }
    &.nav0::before {
      left: 0.4rem;
    }
    &.nav1::before {
      left: 1.4rem;
    }
    &.nav2::before {
      left: 2.4rem;
    }
    .nav-content-item {
      font-size: 0.1rem;
      color: #5a3600;
      line-height: 0.2rem;
      background: #fffbe6;
      border-radius: 0.1rem;
      border: 1px dotted #ffce00;
      padding: 0.1rem 0.14rem;
      .scroll {
        max-height: 48vh;
        overflow-y: scroll;
      }
      .scdivore-standard {
        display: flex;
        align-items: center;
        margin-bottom: 0.05rem;
        &:last-child {
          margin-bottom: 0;
        }
        .score {
          width: 0.4rem;
          background: #ffdb9f;
          border-radius: 0.1rem;
          color: #630200;
          text-align: center;
          line-height: 1;
          padding: 0.04rem 0;
          box-sizing: border-box;
          margin-right: 0.05rem;
        }
      }
    }
  }
}
</style>